export const ru = {
    city_to: 'Куда',
    date_from__gte: 'Дата от',
    date_from__lte: 'Дата до',
    manager: 'Менеджер',
    person: 'Сотрудник',
    tracker_issue: 'Тикет',
    date_placeholder: 'Выберите дату',
};
